import i from "classnames";
import u, { useMemo as d } from "react";
const b = ({
  children: r,
  className: p,
  color: n,
  dataTestId: s = null,
  disableMargin: f = !1,
  noWrap: y = !1,
  size: t = "7",
  tag: g,
  type: o = "heading",
  ...l
}) => {
  const m = g || {
    display: "h1",
    heading: "h1",
    paragraph: "p"
  }[o], c = d(() => {
    if (!t) return "";
    if (typeof t == "string" || typeof t == "number") return `fs-${t}`;
    if (typeof t != "object") return "";
    const a = [];
    return Object.entries(t).forEach(([h, e]) => {
      (typeof e == "string" || typeof e == "number") && a.push(`fs-${h}-${e}`);
    }), a.join(" ");
  }, [t]);
  return u.createElement(
    m,
    {
      className: i(
        p,
        c,
        f && "tvg-typography--disable-margin",
        y && "tvg-typography--no-wrap",
        "tvg-typography",
        `fv-${o}`,
        "fuse-typography-element"
      ),
      "data-testid": s,
      style: { "--typography-color": n || void 0 },
      // This is the css variable for the typography color (see packages/fuse-design/src/styles/typography.css)
      ...l
    },
    r
  );
};
b.displayName = "TypographyComponent";
export {
  b as TypographyComponent
};
